
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/blueguard-middle-east-first-aid-training",
      function () {
        return require("private-next-pages/case-study/blueguard-middle-east-first-aid-training.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/blueguard-middle-east-first-aid-training"])
      });
    }
  